import _ from "lodash";
import { Component, ComponentOptions } from "./component";

export abstract class TemplateComponent extends Component {

    private template: string;

    constructor(template: string, options: ComponentOptions) {
        super(options);
        this.template = template;
    }

    generate(): string {
        var kendoTemplate = kendo.template(this.template.trim().replaceAll("\n", ""));
        var options = _.clone(this.options);

        var content = this.generateContent();
        _.forEach(content, (html, property) => {
            options[property] = html;
        });

        var output = kendoTemplate(options);
        return output;
    }

}
